module.exports = __webpack_public_path__ + "media/duck-hunt.ac7f80d2.wav";